var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight16 = function SvgArrowRight16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.914 6.94 5.621 1.645l-.707.708 5.293 5.292a.5.5 0 0 1 0 .708l-5.293 5.292.707.707 5.293-5.292a1.5 1.5 0 0 0 0-2.122",
    clipRule: "evenodd"
  })));
};
export default SvgArrowRight16;